function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Checkbox from 'ant-design-vue/es/checkbox';
import Popover from 'ant-design-vue/es/popover';
import Icon from 'ant-design-vue/es/icon';
import renderHeader from './header';
import Mixin from './mixin';

var __script__ = {
  name: 'TableHead',
  mixins: [Mixin],
  components: {
    renderHeader: renderHeader,
    Checkbox: Checkbox,
    CheckboxGroup: Checkbox.Group,
    Popover: Popover,
    Icon: Icon
  },
  props: {
    prefixCls: String,
    styleObject: Object,
    columns: Array,
    objData: Object,
    data: Array, // rebuildData
    columnsWidth: Object,
    fixed: {
      type: [Boolean, String],
      default: false
    },
    columnRows: Array,
    fixedColumnRows: Array
  },
  computed: {
    styles: function styles() {
      var style = Object.assign({}, this.styleObject);
      var width = parseInt(this.styleObject.width);
      style.width = width + 'px';
      return style;
    },
    isSelectAll: function isSelectAll() {
      var isSelectAll = true;
      if (!this.data.length) isSelectAll = false;
      if (!this.data.find(function (item) {
        return !item._disabled;
      })) isSelectAll = false; // #1751
      for (var i = 0; i < this.data.length; i++) {
        if (!this.objData[this.data[i]._index]._isChecked && !this.objData[this.data[i]._index]._isDisabled) {
          isSelectAll = false;
          break;
        }
      }
      return isSelectAll;
    },
    headRows: function headRows() {
      var isGroup = this.columnRows.length > 1;
      if (isGroup) {
        return this.fixed ? this.fixedColumnRows : this.columnRows;
      }
      return [this.columns];
    },
    isSelectDisabled: function isSelectDisabled() {
      var isSelectDisabled = false;
      if (!this.data.length) isSelectDisabled = true;
      if (!this.data.find(function (item) {
        return !item._disabled;
      })) isSelectDisabled = true;
      return isSelectDisabled;
    },
    isIndeterminate: function isIndeterminate() {
      var isIndeterminate = false;
      if (!this.isSelectAll) {
        if (this.data.find(function (item) {
          return item._checked;
        })) isIndeterminate = true;
        for (var i = 0; i < this.data.length; i++) {
          if (this.objData[this.data[i]._index]._isChecked) {
            isIndeterminate = true;
            break;
          }
        }
      }
      return isIndeterminate;
    }
  },
  methods: {
    cellClasses: function cellClasses(column) {
      var _ref;

      return [this.prefixCls + '-cell', (_ref = {}, _defineProperty(_ref, this.prefixCls + '-hidden', !this.fixed && column.fixed && (column.fixed === 'left' || column.fixed === 'right')), _defineProperty(_ref, this.prefixCls + '-cell-with-selection', column.type === 'selection'), _ref)];
    },
    scrollBarCellClass: function scrollBarCellClass() {
      var hasRightFixed = false;
      for (var i in this.headRows) {
        for (var j in this.headRows[i]) {
          if (this.headRows[i][j].fixed === 'right') {
            hasRightFixed = true;
            break;
          }
          if (hasRightFixed) break;
        }
      }
      return [_defineProperty({}, this.prefixCls + '-hidden', hasRightFixed)];
    },
    itemClasses: function itemClasses(column, item) {
      return [this.prefixCls + '-filter-select-item', _defineProperty({}, this.prefixCls + '-filter-select-item-selected', column._filterChecked[0] === item.value)];
    },
    itemAllClasses: function itemAllClasses(column) {
      return [this.prefixCls + '-filter-select-item', _defineProperty({}, this.prefixCls + '-filter-select-item-selected', !column._filterChecked.length)];
    },
    selectAll: function selectAll() {
      var status = !this.isSelectAll;
      this.$parent.selectAll(status);
    },
    handleSort: function handleSort(index, type) {
      // 在固定列时，寻找正确的 index #5580
      var column = this.columns.find(function (item) {
        return item._index === index;
      });
      var _index = column._index;


      if (column._sortType === type) {
        type = 'normal';
      }
      this.$parent.handleSort(_index, type);
    },
    handleSortByHead: function handleSortByHead(index) {
      // 在固定列时，寻找正确的 index #5580
      var column = this.columns.find(function (item) {
        return item._index === index;
      });
      if (column.sortable) {
        var type = column._sortType;
        if (type === 'normal') {
          this.handleSort(index, 'asc');
        } else if (type === 'asc') {
          this.handleSort(index, 'desc');
        } else {
          this.handleSort(index, 'normal');
        }
      }
    },
    handleFilter: function handleFilter(index) {
      this.$parent.handleFilter(index);
    },
    handleSelect: function handleSelect(index, value) {
      this.$parent.handleFilterSelect(index, value);
    },
    handleReset: function handleReset(index) {
      this.$parent.handleFilterReset(index);
    },
    handleFilterHide: function handleFilterHide(index) {
      this.$parent.handleFilterHide(index);
    },

    // 因为表头嵌套不是深拷贝，所以没有 _ 开头的方法，在 isGroup 下用此列
    getColumn: function getColumn(rowIndex, index) {
      var isGroup = this.columnRows.length > 1;

      if (isGroup) {
        var id = this.headRows[rowIndex][index].__id;
        return this.columns.filter(function (item) {
          return item.__id === id;
        })[0];
      }
      return this.headRows[rowIndex][index];
    }
  }
};

var render = function render() {
  var _vm = this;var _h = _vm.$createElement;var _c = _vm._self._c || _h;
  return _c('table', {
    style: _vm.styles,
    attrs: {
      "cellspacing": "0",
      "cellpadding": "0",
      "border": "0"
    }
  }, [_c('colgroup', [_vm._l(_vm.columns, function (column, index) {
    return _c('col', {
      key: index,
      attrs: {
        "width": _vm.setCellWidth(column)
      }
    });
  }), _vm._v(" "), _vm.$parent.showVerticalScrollBar ? _c('col', {
    attrs: {
      "width": _vm.$parent.scrollBarWidth
    }
  }) : _vm._e()], 2), _vm._v(" "), _c('thead', _vm._l(_vm.headRows, function (cols, rowIndex) {
    return _c('tr', {
      key: rowIndex
    }, [_vm._l(cols, function (column, index) {
      var _obj;

      return _c('th', {
        key: index,
        class: _vm.alignCls(column),
        attrs: {
          "colspan": column.colSpan,
          "rowspan": column.rowSpan
        }
      }, [_c('div', {
        class: _vm.cellClasses(column)
      }, [column.type === 'expand' ? [!column.renderHeader ? _c('span', [_vm._v(_vm._s(column.title || ''))]) : _c('render-header', {
        attrs: {
          "render": column.renderHeader,
          "column": column,
          "index": index
        }
      })] : column.type === 'selection' ? [_c('Checkbox', {
        attrs: {
          "checked": _vm.isSelectAll,
          "disabled": _vm.isSelectDisabled,
          "indeterminate": _vm.isIndeterminate
        },
        on: {
          "change": _vm.selectAll
        }
      })] : [!column.renderHeader ? _c('span', {
        class: (_obj = {}, _obj[_vm.prefixCls + '-cell-sort'] = column.sortable, _obj),
        on: {
          "click": function click($event) {
            _vm.handleSortByHead(_vm.getColumn(rowIndex, index)._index);
          }
        }
      }, [_vm._v(_vm._s(column.title || '#'))]) : _c('render-header', {
        attrs: {
          "render": column.renderHeader,
          "column": column,
          "index": index
        }
      }), _vm._v(" "), column.sortable ? _c('span', {
        class: [_vm.prefixCls + '-sort']
      }, [_c('Icon', {
        class: {
          on: _vm.getColumn(rowIndex, index)._sortType === 'asc'
        },
        attrs: {
          "type": "caret-up"
        },
        on: {
          "click": function click($event) {
            _vm.handleSort(_vm.getColumn(rowIndex, index)._index, 'asc');
          }
        }
      }), _vm._v(" "), _c('Icon', {
        class: {
          on: _vm.getColumn(rowIndex, index)._sortType === 'desc'
        },
        attrs: {
          "type": "caret-down"
        },
        on: {
          "click": function click($event) {
            _vm.handleSort(_vm.getColumn(rowIndex, index)._index, 'desc');
          }
        }
      })], 1) : _vm._e(), _vm._v(" "), _vm.isPopperShow(column) ? _c('Popover', {
        attrs: {
          "trigger": "click",
          "placement": "bottom",
          "overlayClassName": _vm.prefixCls + "-popper"
        },
        on: {
          "visibleChange": function visibleChange(visibled) {
            !visibled && _vm.handleFilterHide(_vm.getColumn(rowIndex, index)._index);
          }
        },
        model: {
          value: _vm.getColumn(rowIndex, index)._filterVisible,
          callback: function callback($$v) {
            _vm.$set(_vm.getColumn(rowIndex, index), "_filterVisible", $$v);
          },
          expression: "getColumn(rowIndex, index)._filterVisible"
        }
      }, [_c('span', {
        class: _vm.prefixCls + "-filter"
      }, [_c('Icon', {
        class: {
          on: _vm.getColumn(rowIndex, index)._isFiltered
        },
        attrs: {
          "type": "filter",
          "theme": "filled"
        }
      })], 1), _vm._v(" "), _vm.getColumn(rowIndex, index)._filterMultiple ? _c('div', {
        class: [_vm.prefixCls + '-filter-list'],
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('div', {
        class: [_vm.prefixCls + '-filter-list-item']
      }, [_c('checkbox-group', {
        model: {
          value: _vm.getColumn(rowIndex, index)._filterChecked,
          callback: function callback($$v) {
            _vm.$set(_vm.getColumn(rowIndex, index), "_filterChecked", $$v);
          },
          expression: "getColumn(rowIndex, index)._filterChecked"
        }
      }, _vm._l(column.filters, function (item, index) {
        return _c('div', {
          key: index
        }, [_c('checkbox', {
          attrs: {
            "value": item.value
          }
        }, [_vm._v(_vm._s(item.label))])], 1);
      }), 0)], 1), _vm._v(" "), _c('div', {
        class: [_vm.prefixCls + '-filter-footer']
      }, [_c('a', {
        attrs: {
          "href": "javascript:;",
          "disabled": !_vm.getColumn(rowIndex, index)._filterChecked.length
        },
        on: {
          "click": function click($event) {
            _vm.handleFilter(_vm.getColumn(rowIndex, index)._index);
          }
        }
      }, [_vm._v("确定")]), _vm._v(" "), _c('a', {
        attrs: {
          "href": "javascript:;"
        },
        on: {
          "click": function click($event) {
            _vm.handleReset(_vm.getColumn(rowIndex, index)._index);
          }
        }
      }, [_vm._v("重置")])])]) : _c('div', {
        class: [_vm.prefixCls + '-filter-list'],
        attrs: {
          "slot": "content"
        },
        slot: "content"
      }, [_c('ul', {
        class: [_vm.prefixCls + '-filter-list-single']
      }, [_c('li', {
        class: _vm.itemAllClasses(_vm.getColumn(rowIndex, index)),
        on: {
          "click": function click($event) {
            _vm.handleReset(_vm.getColumn(rowIndex, index)._index);
          }
        }
      }, [_vm._v("全部")]), _vm._v(" "), _vm._l(column.filters, function (item, subIndex) {
        return _c('li', {
          key: subIndex,
          class: _vm.itemClasses(_vm.getColumn(rowIndex, index), item),
          on: {
            "click": function click($event) {
              _vm.handleSelect(_vm.getColumn(rowIndex, index)._index, item.value);
            }
          }
        }, [_vm._v(_vm._s(item.label))]);
      })], 2)])]) : _vm._e()]], 2)]);
    }), _vm._v(" "), _vm.$parent.showVerticalScrollBar && rowIndex === 0 ? _c('th', {
      class: _vm.scrollBarCellClass(),
      attrs: {
        "rowspan": _vm.headRows.length
      }
    }) : _vm._e()], 2);
  }), 0)]);
};
var staticRenderFns = [];
var __template__ = { render: render, staticRenderFns: staticRenderFns };

export default Object.assign({}, __script__, __template__);